import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logActivity } from '../logger';
import { 
  Box, Typography, Button, TextField, Table, TableBody, TableCell, 
  TableHead, TableRow, Dialog, DialogTitle, DialogContent, DialogActions,
  Paper, IconButton, Chip, Drawer, Grid, Card, CardContent, Divider, TableSortLabel,
  Avatar, List, ListItem, ListItemText, ListItemIcon, FormControl, InputLabel, Select, MenuItem,
  Switch, FormControlLabel, InputAdornment, Tooltip, CircularProgress, TablePagination, Stack, Tabs, Tab, Fade, Grow, Rating, Alert
} from '@mui/material';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import FilterListIcon from '@mui/icons-material/FilterList';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import BusinessIcon from '@mui/icons-material/Business';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import PublicIcon from '@mui/icons-material/Public';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import ArchitectureIcon from '@mui/icons-material/Architecture';
import ShieldIcon from '@mui/icons-material/Shield';
import WorkIcon from '@mui/icons-material/Work';
import CloudIcon from '@mui/icons-material/Cloud';
import axios from 'axios';
import Loading from '../components/Loading';
import API_URL from '../config';

function Clients() {
  const navigate = useNavigate();
    const [clients, setClients] = useState([]);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [createLoading, setCreateLoading] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [newClient, setNewClient] = useState({ name: '', crmID: '', crmGUID: '', contact_info: '', email: '', phone: '', country_id: '', client_type: 'Contractor', account_type: 'CRM', rank: '1', external_rank: '1', ventures_onsite_rank: '', cash: '', credit: '' });
  const [search, setSearch] = useState('');
  const [filterCountry, setFilterCountry] = useState(() => {
    try {
        const userCountries = JSON.parse(localStorage.getItem('user_countries') || '[]');
        return userCountries.length > 0 ? userCountries[0] : '';
    } catch (e) {
        return '';
    }
  });
  const [filterRank, setFilterRank] = useState('');
  const [filterType, setFilterType] = useState('');
  const [filterLetter, setFilterLetter] = useState('All');
  const [tabValue, setTabValue] = useState(0);
  const [crmLoading, setCrmLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [sortCol, setSortCol] = useState('Name');
  const [sortOrder, setSortOrder] = useState('asc');
  const [files, setFiles] = useState({
      license_1: null,
      license_2: null,
      tax_card: null,
      establishment_card: null,
      application_pdf: null
  });
  const userRole = localStorage.getItem('user_role');

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const fetchClients = async () => {
    // setLoading(true); // Removed to prevent re-rendering the whole page on search
    try {
      const params = {};
      if (search) params.search = search;
      if (filterCountry) params.country_id = filterCountry;
      if (filterRank) params.rank = filterRank;
      if (filterType) params.client_type = filterType;

      const resClients = await axios.get(`${API_URL}/clients`, { headers, params });
      setClients(resClients.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const getCountries = async () => {
        try {
            const res = await axios.get(`${API_URL}/setup/countries`, { headers });
            setCountries(res.data);
        } catch (error) {
            console.error(error);
        }
    }
    getCountries();
  }, []);

  useEffect(() => {
    setPage(0);
    const delayDebounceFn = setTimeout(() => {
      fetchClients();
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [search, filterCountry, filterRank, filterType, filterLetter, tabValue]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const clientIdParam = params.get('client_id');
    const actionParam = params.get('action');

    if (clientIdParam) {
        // Redirect to ClientDetails with the action parameter
        if (actionParam) {
            navigate(`/clients/${clientIdParam}?action=${actionParam}`);
        } else {
            navigate(`/clients/${clientIdParam}`);
        }
    }
  }, [navigate]);

  const handleFileChange = (e) => {
      setFiles({ ...files, [e.target.name]: e.target.files[0] });
  };

  const handleFetchFromCRM = async () => {
        if (!newClient.crmID) {
            alert("Please enter a CRM ID first.");
            return;
        }
        setCrmLoading(true);
        try {
            const res = await axios.get(`${API_URL}/clients/fetch-crm`, {
                headers,
                params: { crm_id: newClient.crmID }
            });
            const data = res.data;
            if (data.found) {
                setNewClient(prev => {
                    let newCountryId = prev.country_id;
                    if (data.country) {
                        const countryMatch = countries.find(c => c.name.toLowerCase() === data.country.toLowerCase());
                        if (countryMatch) {
                            newCountryId = countryMatch.id;
                        }
                    }
                    
                    return {
                        ...prev,
                        name: data.name || prev.name,
                        email: data.email || prev.email,
                        phone: data.phone || prev.phone,
                        contact_info: data.contact_info || prev.contact_info,
                          country_id: newCountryId,
                          crmGUID: data.crmGUID || prev.crmGUID
                    };
                });
                alert("Client data fetched from CRM successfully!");
            }
        } catch (err) {
            console.error(err);
            if (err.response && err.response.data && err.response.data.message) {
                alert(`Error: ${err.response.data.message}`);
            } else {
                alert("Failed to fetch from CRM. Please check the ID and try again.");
            }
        } finally {
            setCrmLoading(false);
        }
    };

  const handleCreate = async () => {
    logActivity('Clients', 'Add Record');
    setCreateLoading(true);

    // Check if CRM + Qatar/Kuwait requires documents
    const selectedCountry = countries.find(c => String(c.id) === String(newClient.country_id));
    const isQatarKuwait = selectedCountry && ['qatar', 'kuwait'].includes(selectedCountry.name.toLowerCase());
    const isCrmAccount = newClient.account_type === 'CRM';
    const hasRequiredDocs = files.license_1 && files.license_2 && files.tax_card && files.establishment_card && files.application_pdf;
    let effectiveAccountType = newClient.account_type;
    if (isCrmAccount && isQatarKuwait && !hasRequiredDocs) {
      effectiveAccountType = 'PM';
    }
    try {
      const formData = new FormData();
      formData.append('name', newClient.name);
      formData.append('crmID', newClient.crmID);
      formData.append('crmGUID', newClient.crmGUID);
      formData.append('client_type', newClient.client_type);
      formData.append('account_type', effectiveAccountType);
      formData.append('rank', newClient.rank);
      formData.append('external_rank', newClient.external_rank);
      formData.append('ventures_onsite_rank', newClient.ventures_onsite_rank || '');
      formData.append('cash', newClient.cash || '');
      formData.append('credit', newClient.credit || '');
      
      // Auto-approve if it came from CRM (has crmID)
      if (newClient.crmID || newClient.crmGUID) {
         formData.append('status', 'Approved');
         formData.append('approved', 'true');
      }

      formData.append('contact_info', newClient.contact_info);
      formData.append('email', newClient.email);
      formData.append('phone', newClient.phone);
      formData.append('country_id', newClient.country_id || '');
      
      if (files.license_1) formData.append('license_1', files.license_1);
      if (files.license_2) formData.append('license_2', files.license_2);
      if (files.tax_card) formData.append('tax_card', files.tax_card);
      if (files.establishment_card) formData.append('establishment_card', files.establishment_card);
      if (files.application_pdf) formData.append('application_pdf', files.application_pdf);

      await axios.post(`${API_URL}/clients`, formData, { 
          headers: { ...headers, 'Content-Type': 'multipart/form-data' } 
      });
      setOpenAdd(false);
      fetchClients();
        setNewClient({ name: '', crmID: '', crmGUID: '', contact_info: '', email: '', phone: '', country_id: '', client_type: 'Contractor', account_type: 'CRM', rank: '1', external_rank: '1', ventures_onsite_rank: '', cash: '', credit: '' });
      setFiles({ license_1: null, license_2: null, tax_card: null, establishment_card: null, application_pdf: null });
    } catch (err) {
      alert('Error creating client');
    } finally {
      setCreateLoading(false);
    }
  };

  const handleViewDetails = async (client) => {
      logActivity('Clients', 'Open Record', client.id);
      navigate(`/clients/${client.id}`);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSort = (colId) => {
    const isAsc = sortCol === colId && sortOrder === 'asc';
    setSortOrder(isAsc ? 'desc' : 'asc');
    setSortCol(colId);
  };

  const filteredClients = clients.filter(c => {
    if (filterLetter !== 'All') {
      if (!(c.name && c.name.toUpperCase().startsWith(filterLetter))) return false;
    }
    if (tabValue === 1 && c.status !== 'Pending') return false;
    if (tabValue === 2 && c.status !== 'Approved') return false;
    if (tabValue === 3 && c.status !== 'Rejected') return false;
    if (tabValue === 4 && c.status === 'Not registered') return true;
    else if (tabValue === 4) return false;
    return true;
  }).sort((a, b) => {
    let valA = a[sortCol.toLowerCase().replace(/ /g, '_')] || '';
    let valB = b[sortCol.toLowerCase().replace(/ /g, '_')] || '';
    
    // Custom mapping for specific column headers
    if (sortCol === 'Client' || sortCol === 'Name') { valA = a.name || ''; valB = b.name || ''; }
    else if (sortCol === 'Type') { valA = a.client_type || ''; valB = b.client_type || ''; }
    else if (sortCol === 'Email' || sortCol === 'Contact Email') { valA = a.email || ''; valB = b.email || ''; }
    else if (sortCol === 'CRM' || sortCol === 'CRM ID') { valA = a.crmID || ''; valB = b.crmID || ''; }
    else if (sortCol === 'Rank') { valA = a.rank ? Number(a.rank) : null; valB = b.rank ? Number(b.rank) : null; }
    else if (sortCol === 'ERank' || sortCol === 'E.Rank') { valA = a.ventures_onsite_rank ? Number(a.ventures_onsite_rank) : null; valB = b.ventures_onsite_rank ? Number(b.ventures_onsite_rank) : null; }
    else if (sortCol === 'VO') { valA = a.ventures_onsite_rank ? Number(a.ventures_onsite_rank) : null; valB = b.ventures_onsite_rank ? Number(b.ventures_onsite_rank) : null; }
    
    // Always put null/empty values at the bottom
    if (valA === null && valB !== null) return 1;
    if (valB === null && valA !== null) return -1;
    if (valA === null && valB === null) return 0;

    if (typeof valA === 'number' && typeof valB === 'number') {
        if (valA < valB) return sortOrder === 'asc' ? -1 : 1;
        if (valA > valB) return sortOrder === 'asc' ? 1 : -1;
        return 0;
    }

    const strA = String(valA).toLowerCase();
    const strB = String(valB).toLowerCase();
    if (strA < strB) return sortOrder === 'asc' ? -1 : 1;
    if (strA > strB) return sortOrder === 'asc' ? 1 : -1;
    return 0;
  });

  if (loading) return <Loading message="Loading Clients..." />;

  const letters = ['All', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')];

  const summary = {
      total: clients.length,
      crm: clients.filter(c => c.account_type === 'CRM').length,
      pm: clients.filter(c => c.account_type === 'PM').length,
      contractor: clients.filter(c => c.client_type === 'Contractor').length,
      stakeHolder: clients.filter(c => c.client_type === 'Stake Holders').length,
      consultant: clients.filter(c => c.client_type === 'Consultant').length
  };

  return (
    <Box sx={{ width: '100%', overflowX: 'hidden', boxSizing: 'border-box', pb: 6, px: { xs: 1, md: 3 }, bgcolor: '#f4f6f8', minHeight: '100vh' }}>
      
      {/* Modern Gradient Header */}
      <Grow in={true} timeout={500}>
        <Box sx={{ 
            mb: 4, 
            mt: 2, 
            p: 4, 
            borderRadius: 4, 
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', 
            color: 'white',
            boxShadow: '0 10px 30px rgba(30, 60, 114, 0.2)',
            position: 'relative',
            overflow: 'hidden'
        }}>
            

            <Box sx={{ position: 'relative', zIndex: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                <Box>
                    <Typography variant="h4" fontWeight="800" sx={{ mb: 1, letterSpacing: 0.5, display: 'flex', alignItems: 'center', gap: 2, color: 'white' }}>
                        <BusinessIcon sx={{ fontSize: 36, color: '#90caf9' }} />
                        Client Management
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                        Manage and track all company clients
                    </Typography>
                </Box>
                <Button 
                    variant="contained" 
                    color="secondary"
                    startIcon={<EqualizerIcon />} 
                    onClick={() => navigate('/client-statistics')}
                    sx={{ mt: { xs: 2, sm: 0 }, borderRadius: 2, fontWeight: 'bold' }}
                >
                    View Pro Statistics
                </Button>
            </Box>
            
            {/* Decorative background circles */}
            <Box sx={{ position: 'absolute', top: -50, right: -50, width: 200, height: 200, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />
            <Box sx={{ position: 'absolute', bottom: -100, right: 100, width: 250, height: 250, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />
        </Box>
      </Grow>

      {/* Styled Metrics Cards */}
      <Grow in={true} timeout={800}>
      <Grid container spacing={2} sx={{ mb: 4 }}>
          {[
              { label: 'Total Clients', value: summary.total, icon: <PeopleAltIcon />, color: '#1976d2', bg: '#e3f2fd' },
              { label: 'CRM Synced', value: summary.crm, icon: <CloudIcon />, color: '#0288d1', bg: '#e1f5fe' },
              { label: 'PM Managed', value: summary.pm, icon: <ShieldIcon />, color: '#2e7d32', bg: '#e8f5e9' },
              { label: 'Contractors', value: summary.contractor, icon: <ArchitectureIcon />, color: '#ed6c02', bg: '#fff3e0' },
              { label: 'Stakeholders', value: summary.stakeHolder, icon: <BusinessIcon />, color: '#9c27b0', bg: '#f3e5f5' },
              { label: 'Consultants', value: summary.consultant, icon: <WorkIcon />, color: '#009688', bg: '#e0f2f1' }
          ].map((metric, idx) => (
              <Grid item xs={6} sm={4} md={2} key={idx}>
                  <Paper elevation={0} sx={{ 
                      p: 2.5, 
                      borderRadius: 4, 
                      bgcolor: 'white', 
                      boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                      transition: 'transform 0.2s',
                      border: '1px solid rgba(0,0,0,0.04)',
                      '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 8px 25px rgba(0,0,0,0.06)' }
                  }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                          <Avatar sx={{ bgcolor: metric.bg, color: metric.color, width: 48, height: 48, mb: 1.5, boxShadow: `0 4px 10px ${metric.bg}` }}>
                              {metric.icon}
                          </Avatar>
                          <Typography variant="h5" color={metric.color} fontWeight="800">{metric.value}</Typography>
                          <Typography variant="caption" color="text.secondary" fontWeight="700" textTransform="uppercase" letterSpacing={0.5}>{metric.label}</Typography>
                      </Box>
                  </Paper>
              </Grid>
          ))}
      </Grid>
      </Grow>

      {/* Tabs & Search Controls */}
      <Grow in={true} timeout={1000}>
      <Paper elevation={0} sx={{ borderRadius: 4, border: 'none', boxShadow: '0 4px 20px rgba(0,0,0,0.04)', mb: 4, overflow: 'hidden', bgcolor: 'white' }}>
        <Box sx={{ bgcolor: 'white', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 3, pt: 1, flexWrap: 'wrap', gap: 2 }}>
            <Tabs 
              value={tabValue} 
              onChange={(e, newValue) => setTabValue(newValue)} 
              variant="scrollable"
              scrollButtons="auto"
              TabIndicatorProps={{ sx: { height: 3, borderRadius: '3px 3px 0 0' } }}
              sx={{ 
                  '& .MuiTab-root': { fontWeight: 600, textTransform: 'none', minHeight: 60, fontSize: '0.95rem' },
                  '& .Mui-selected': { color: 'primary.main' }
              }}
            >
              <Tab label="All Clients" />
              <Tab label="Pending Approval" />
              <Tab label="Approved" />
              <Tab label="Rejected" />
              <Tab label="Not Registered" />
            </Tabs>
            <Button 
                variant="contained" 
                startIcon={<AddIcon />} 
                onClick={() => setOpenAdd(true)}
                sx={{ 
                    borderRadius: 2, 
                    px: 3, 
                    py: 1.2, 
                    boxShadow: '0 8px 16px rgba(25, 118, 210, 0.25)',
                    textTransform: 'none',
                    fontWeight: 'bold',
                    whiteSpace: 'nowrap',
                    background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)',
                    mb: 1
                }}
            >
                New Client
            </Button>
        </Box>

        <Box sx={{ p: 3, bgcolor: '#fafafa' }}>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 3, alignItems: { xs: 'stretch', md: 'center' } }}>
                 <TextField 
                    size="medium" 
                    placeholder="Search by name, email, or phone..." 
                    value={search} 
                    onChange={(e) => setSearch(e.target.value)}
                    InputProps={{
                        startAdornment: <SearchIcon color="primary" sx={{ mr: 1.5 }} />
                    }}
                    sx={{ flexGrow: 1, '& .MuiOutlinedInput-root': { borderRadius: 3, bgcolor: 'white', boxShadow: '0 2px 10px rgba(0,0,0,0.02)', '& fieldset': { borderColor: 'transparent' }, '&:hover fieldset': { borderColor: '#e0e0e0' }, '&.Mui-focused fieldset': { borderColor: 'primary.main' } } }}
                />
                
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <FilterListIcon sx={{ color: 'text.secondary' }} />
                    <FormControl size="medium" sx={{ minWidth: 150 }}>
                        <InputLabel>Filter by Rank</InputLabel>
                        <Select
                            value={filterRank}
                            label="Filter by Rank"
                            onChange={(e) => setFilterRank(e.target.value)}
                            sx={{ borderRadius: 3, bgcolor: 'white', boxShadow: '0 2px 10px rgba(0,0,0,0.02)', '& .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent' }, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#e0e0e0' } }}
                        >
                            <MenuItem value=""><em>All Ranks</em></MenuItem>
                            {[1, 2, 3].map((r) => (
                                <MenuItem key={r} value={r}>Tier {r}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl size="medium" sx={{ minWidth: 150 }}>
                        <InputLabel>Filter by Type</InputLabel>
                        <Select
                            value={filterType}
                            label="Filter by Type"
                            onChange={(e) => setFilterType(e.target.value)}
                            sx={{ borderRadius: 3, bgcolor: 'white', boxShadow: '0 2px 10px rgba(0,0,0,0.02)', '& .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent' }, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#e0e0e0' } }}
                        >
                            <MenuItem value=""><em>All Types</em></MenuItem>
                            {['Contractor', 'Consultant', 'Stake Holders'].map((t) => (
                                <MenuItem key={t} value={t}>{t}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl size="medium" sx={{ minWidth: 200 }}>
                        <InputLabel>Filter by Country</InputLabel>
                        <Select
                            value={filterCountry}
                            label="Filter by Country"
                            onChange={(e) => setFilterCountry(e.target.value)}
                            sx={{ borderRadius: 3, bgcolor: 'white', boxShadow: '0 2px 10px rgba(0,0,0,0.02)', '& .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent' }, '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#e0e0e0' } }}
                        >
                            <MenuItem value=""><em>Global Overview</em></MenuItem>
                            {countries.map((c) => (
                                <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </Box>

            <Box sx={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                gap: 1, 
                mt: 3,
                pt: 2.5,
                borderTop: '1px dashed #e0e0e0'
            }}>
                <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', mr: 2, color: 'primary.main', fontWeight: '800', letterSpacing: 1 }}>FAST INDEX:</Typography>
                {letters.map(letter => (
                    <Box
                        key={letter}
                        onClick={() => setFilterLetter(letter)}
                        sx={{
                            cursor: 'pointer',
                            minWidth: letter === 'All' ? 48 : 32,
                            height: 32,
                            px: letter === 'All' ? 1.5 : 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '8px',
                            fontWeight: filterLetter === letter ? '800' : '600',
                            bgcolor: filterLetter === letter ? '#1976d2' : 'white',
                            color: filterLetter === letter ? 'white' : 'text.secondary',
                            boxShadow: filterLetter === letter ? '0 4px 10px rgba(25, 118, 210, 0.3)' : '0 2px 5px rgba(0,0,0,0.05)',
                            transition: 'all 0.2s',
                            '&:hover': {
                                bgcolor: filterLetter === letter ? '#1565c0' : '#f0f0f0',
                                color: filterLetter === letter ? 'white' : 'text.primary',
                                transform: 'translateY(-2px)'
                            }
                        }}
                    >
                        <Typography variant="caption" sx={{ fontSize: '0.8rem' }}>{letter}</Typography>
                    </Box>
                ))}
            </Box>
        </Box>
      </Paper>
      </Grow>
      
      {/* Table Data Container */}
      <Grow in={true} timeout={1200}>
      <Paper elevation={0} sx={{ borderRadius: 4, overflow: 'hidden', border: 'none', boxShadow: '0 10px 40px rgba(0,0,0,0.06)', width: '100%', bgcolor: 'white' }}>
        <Box sx={{ overflowX: 'auto', width: '100%', display: 'block' }}>
        <Table sx={{ width: '100%', tableLayout: 'auto', '& .MuiTableCell-root': { borderColor: '#f0f0f0', py: 2.5 } }}>
            <TableHead sx={{ bgcolor: '#f8fafc' }}>
                <TableRow>
                    {['Client', 'Type', 'Rank', 'ERank', 'CRM', 'Email', 'Phone', 'Country'].map(head => (
                        <TableCell key={head} sx={{ fontWeight: 800, color: '#475569', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                            <TableSortLabel
                                active={sortCol === head}
                                direction={sortCol === head ? sortOrder : 'asc'}
                                onClick={() => handleSort(head)}
                            >
                                {head}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
            {filteredClients.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(c => (
                <TableRow 
                  key={c.id} 
                  hover 
                  onClick={() => handleViewDetails(c)}
                  sx={{ 
                      cursor: 'pointer',
                      '&:last-child td, &:last-child th': { border: 0 },
                      transition: 'background-color 0.2s, transform 0.1s',
                      '&:hover': { bgcolor: '#f8fbff !important' }
                  }}
                >
                    <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5 }}>
                            <Avatar sx={{ 
                                bgcolor: c.account_type === 'PM' ? '#f3e5f5' : '#e3f2fd', 
                                color: c.account_type === 'PM' ? '#9c27b0' : '#1565c0', 
                                fontWeight: '900', 
                                width: 46, height: 46, 
                                boxShadow: c.account_type === 'PM' ? '0 4px 10px rgba(156,39,176,0.2)' : '0 4px 10px rgba(25,118,210,0.2)'
                            }}>
                                {c.name[0]?.toUpperCase()}
                            </Avatar>
                            <Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <Tooltip title={c.name} arrow placement="top-start">
                                        <Typography fontWeight="700" sx={{ 
                                            color: '#1e293b', 
                                            fontSize: '0.95rem',
                                            maxWidth: '180px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}>
                                            {c.name}
                                        </Typography>
                                    </Tooltip>
                                    {c.status === 'Approved' ? 
                                        <Tooltip title="Approved" arrow><CheckCircleIcon sx={{ fontSize: '1rem', color: '#10b981' }} /></Tooltip> : 
                                     c.status === 'Rejected' ?
                                        <Tooltip title="Rejected" arrow><CancelIcon sx={{ fontSize: '1rem', color: '#ef4444' }} /></Tooltip> :
                                     c.status === 'Not registered' ?
                                        <Tooltip title="Not Registered" arrow><CancelIcon sx={{ fontSize: '1rem', color: '#94a3b8' }} /></Tooltip> :
                                        <Tooltip title="Pending" arrow><AssignmentIcon sx={{ fontSize: '1rem', color: '#f59e0b' }} /></Tooltip>
                                    }
                                </Box>
                                <Typography variant="caption" sx={{ color: c.account_type === 'PM' ? '#9c27b0' : '#64748b', fontWeight: 600, display: 'block', mt: 0.25 }}>
                                    {c.account_type || 'N/A'} Account
                                </Typography>
                            </Box>
                        </Box>
                    </TableCell>
                    <TableCell sx={{ color: '#334155', fontWeight: 600, fontSize: '0.85rem' }}>
                        <Tooltip title={c.client_type || ''} arrow placement="top-start">
                            <Box sx={{ 
                                maxWidth: '130px', 
                                whiteSpace: 'nowrap', 
                                overflow: 'hidden', 
                                textOverflow: 'ellipsis' 
                            }}>
                                {c.client_type || '-'}
                            </Box>
                        </Tooltip>
                    </TableCell>
                    <TableCell sx={{ color: '#334155', fontWeight: 600, fontSize: '0.85rem' }}>
                        {c.rank ? <Rating value={Number(c.rank)} max={3} readOnly size="small" /> : '-'}
                    </TableCell>
                    <TableCell sx={{ color: '#334155', fontWeight: 600, fontSize: '0.85rem' }}>{c.ventures_onsite_rank ? c.ventures_onsite_rank : '-'}</TableCell>
                    <TableCell><Chip label={c.crmID || 'N/A'} size="small" sx={{ borderRadius: 1.5, fontWeight: 700, bgcolor: '#f1f5f9', color: '#475569', border: '1px solid #e2e8f0', px: 0.5 }} /></TableCell>
                    <TableCell sx={{ color: '#334155', fontWeight: 600, fontSize: '0.85rem' }}>{c.email || '-'}</TableCell>
                    <TableCell sx={{ color: '#334155', fontWeight: 600, fontSize: '0.85rem' }}>{c.phone || '-'}</TableCell>
                    <TableCell sx={{ color: '#334155', fontWeight: 600, fontSize: '0.85rem' }}>{c.country || '-'}</TableCell>
                </TableRow>
            ))}
            {filteredClients.length === 0 && (
                <TableRow>
                    <TableCell colSpan={8} align="center" sx={{ py: 10 }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', opacity: 0.7 }}>
                            <Box sx={{ p: 3, borderRadius: '50%', bgcolor: '#f1f5f9', mb: 3 }}>
                                <BusinessIcon sx={{ fontSize: 64, color: '#94a3b8' }} />
                            </Box>
                            <Typography variant="h5" sx={{ color: '#475569', fontWeight: 800, mb: 1 }}>No Clients Found</Typography>
                            <Typography variant="body1" sx={{ color: '#64748b', maxWidth: 400 }}>We couldn't find any clients matching your current filters. Try adjusting the search or add a new client to the CRM.</Typography>
                        </Box>
                    </TableCell>
                </TableRow>
            )}
            </TableBody>
        </Table>
        </Box>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component="div"
          count={filteredClients.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{ borderTop: '1px solid #f0f0f0', bgcolor: '#fafafa', '& .MuiTablePagination-toolbar': { minHeight: 64 } }}
        />
      </Paper>
      </Grow>

      {/* Add Client Dialog */}
      <Dialog open={openAdd} onClose={() => setOpenAdd(false)} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: 4, overflow: 'hidden' } }}>
        <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            Add New Client
            <IconButton size="small" onClick={() => setOpenAdd(false)} sx={{ color: 'white' }}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: { xs: 2, sm: 3 }, bgcolor: '#f8fafc' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                <Paper elevation={0} sx={{ p: 2.5, borderRadius: 3, border: '1px solid #e2e8f0' }}>
                    <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 800, color: '#64748b', textTransform: 'uppercase' }}>Basic Information</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <TextField label="Client Name *" fullWidth value={newClient.name} onChange={e => setNewClient({...newClient, name: e.target.value})} variant="outlined" error={!newClient.name.trim()} helperText={!newClient.name.trim() ? 'Required' : ''} />
                        
                        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
                            <TextField 
                                label="CRM ID" 
                                fullWidth 
                                value={newClient.crmID} 
                                onChange={e => setNewClient({...newClient, crmID: e.target.value})} 
                            />
                            <Tooltip title="Fetch Data from CRM Platform">
                                <span>
                                    <Button 
                                        variant="contained" 
                                        color="secondary" 
                                        onClick={handleFetchFromCRM} 
                                        disabled={crmLoading || !newClient.crmID}
                                        sx={{ height: 56, width: { xs: '100%', sm: 'auto' }, px: 3, whiteSpace: 'nowrap', borderRadius: 2, fontWeight: 'bold', boxShadow: '0 4px 10px rgba(156,39,176,0.3)' }}
                                    >
                                        {crmLoading ? <CircularProgress size={24} color="inherit" /> : <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><CloudDownloadIcon /> Fetch CRM</Box>}
                                    </Button>
                                </span>
                            </Tooltip>
                        </Box>
                    </Box>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={12} sm={6}>
                            <TextField label="Email *" fullWidth value={newClient.email} onChange={e => setNewClient({...newClient, email: e.target.value})} error={!newClient.email.trim()} helperText={!newClient.email.trim() ? 'Required' : ''} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField label="Phone *" fullWidth value={newClient.phone} onChange={e => setNewClient({...newClient, phone: e.target.value})} error={!newClient.phone.trim()} helperText={!newClient.phone.trim() ? 'Required' : ''} />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField label="Additional Contact Info" fullWidth multiline rows={2} value={newClient.contact_info} onChange={e => setNewClient({...newClient, contact_info: e.target.value})} />
                        </Grid>
                    </Grid>
                </Paper>

                <Paper elevation={0} sx={{ p: 2.5, borderRadius: 3, border: '1px solid #e2e8f0' }}>
                    <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 800, color: '#64748b', textTransform: 'uppercase' }}>Classification</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth>
                                <InputLabel>Country</InputLabel>
                                <Select
                                    value={newClient.country_id}
                                    label="Country"
                                    onChange={e => setNewClient({...newClient, country_id: e.target.value})}
                                >
                                    {countries.map((c) => (
                                        <MenuItem key={c.id} value={c.id}>
                                            {c.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth>
                                <InputLabel>Client Type</InputLabel>
                                <Select
                                    value={newClient.client_type}
                                    label="Client Type"
                                    onChange={e => setNewClient({...newClient, client_type: e.target.value})}
                                >
                                    <MenuItem value="Contractor">Contractor</MenuItem>
                                    <MenuItem value="Stake Holder">Stake Holder</MenuItem>
                                    <MenuItem value="Consultant">Consultant</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth>
                                <InputLabel>Account Type</InputLabel>
                                <Select
                                    value={newClient.account_type}
                                    label="Account Type"
                                    onChange={e => setNewClient({...newClient, account_type: e.target.value})}
                                >
                                    <MenuItem value="CRM">CRM</MenuItem>
                                    <MenuItem value="PM">PM</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth>
                                <Box sx={{ border: '1px solid #c4c4c4', borderRadius: 1, p: '4.5px 14px', minHeight: 56, display: 'flex', flexDirection: 'column', position: 'relative', '&:hover': { borderColor: 'black' }, '&:focus-within': { borderColor: '#1976d2', borderWidth: 2 } }}>
                                    <Typography variant="caption" sx={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '0.75rem', position: 'absolute', top: -9, left: 10, bgcolor: 'white', px: 0.5 }}>Internal Rank</Typography>
                                    <Rating
                                        value={Number(newClient.rank) || 1}
                                        max={3}
                                        sx={{ mt: 1.5 }}
                                        onChange={(event, newValue) => {
                                            setNewClient({...newClient, rank: newValue ? newValue.toString() : '1'});
                                        }}
                                    />
                                </Box>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth>
                                <Box sx={{ border: '1px solid #c4c4c4', borderRadius: 1, p: '4.5px 14px', minHeight: 56, display: 'flex', flexDirection: 'column', position: 'relative', '&:hover': { borderColor: 'black' }, '&:focus-within': { borderColor: '#1976d2', borderWidth: 2 } }}>
                                    <Typography variant="caption" sx={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: '0.75rem', position: 'absolute', top: -9, left: 10, bgcolor: 'white', px: 0.5 }}>External Rank</Typography>
                                    <Rating
                                        value={Number(newClient.external_rank) || 1}
                                        max={3}
                                        sx={{ mt: 1.5 }}
                                        onChange={(event, newValue) => {
                                            setNewClient({...newClient, external_rank: newValue ? newValue.toString() : '1'});
                                        }}
                                    />
                                </Box>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                label="ERank"
                                fullWidth
                                type="number"
                                value={newClient.ventures_onsite_rank}
                                onChange={(e) => setNewClient({...newClient, ventures_onsite_rank: e.target.value})}
                                inputProps={{ min: 0 }}
                            />
                        </Grid>
                    </Grid>
                </Paper>
                
                <Paper elevation={0} sx={{ p: 2.5, borderRadius: 3, border: '1px solid #e2e8f0' }}>
                    <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 800, color: '#64748b', textTransform: 'uppercase' }}>Payment Details</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField label="Cash" fullWidth value={newClient.cash} onChange={e => setNewClient({...newClient, cash: e.target.value})} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField label="Credit" fullWidth value={newClient.credit} onChange={e => setNewClient({...newClient, credit: e.target.value})} />
                        </Grid>
                    </Grid>
                </Paper>
                
                <Paper elevation={0} sx={{ p: 2.5, borderRadius: 3, border: '1px solid #e2e8f0', bgcolor: '#f1f5f9' }}>
                    <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 800, color: '#475569', textTransform: 'uppercase' }}>Required Documents</Typography>
                    {(() => {
                        const sel = countries.find(c => String(c.id) === String(newClient.country_id));
                        const isQK = sel && ['qatar', 'kuwait'].includes(sel.name.toLowerCase());
                        const isCrm = newClient.account_type === 'CRM';
                        const allUploaded = files.license_1 && files.license_2 && files.tax_card && files.establishment_card && files.application_pdf;
                        if (isCrm && isQK && !allUploaded) return (
                            <Alert severity="warning" sx={{ mb: 2 }}>
                                All documents are required to sync this account to CRM for {sel.name}. If you create without uploading all documents, this account will be saved as <strong>PM only</strong> and will <strong>not sync to CRM</strong>.
                            </Alert>
                        );
                        if (isCrm && isQK && allUploaded) return (
                            <Alert severity="success" sx={{ mb: 2 }}>All required documents uploaded — account will sync to CRM.</Alert>
                        );
                        return null;
                    })()}
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Button variant="outlined" component="label" fullWidth size="medium" sx={{ borderRadius: 2, bgcolor: 'white' }}>
                                License 1 (Img)
                                <input type="file" hidden name="license_1" accept="image/*" onChange={handleFileChange} />
                            </Button>
                            {files.license_1 && <Typography variant="caption" display="block" noWrap sx={{ mt: 0.5, color: 'primary.main', fontWeight: 'bold' }}>✓ {files.license_1.name}</Typography>}
                        </Grid>
                        <Grid item xs={6}>
                            <Button variant="outlined" component="label" fullWidth size="medium" sx={{ borderRadius: 2, bgcolor: 'white' }}>
                                License 2 (Img)
                                <input type="file" hidden name="license_2" accept="image/*" onChange={handleFileChange} />
                            </Button>
                            {files.license_2 && <Typography variant="caption" display="block" noWrap sx={{ mt: 0.5, color: 'primary.main', fontWeight: 'bold' }}>✓ {files.license_2.name}</Typography>}
                        </Grid>
                        <Grid item xs={6}>
                            <Button variant="outlined" component="label" fullWidth size="medium" sx={{ borderRadius: 2, bgcolor: 'white' }}>
                                Tax Card (Img)
                                <input type="file" hidden name="tax_card" accept="image/*" onChange={handleFileChange} />
                            </Button>
                            {files.tax_card && <Typography variant="caption" display="block" noWrap sx={{ mt: 0.5, color: 'primary.main', fontWeight: 'bold' }}>✓ {files.tax_card.name}</Typography>}
                        </Grid>
                        <Grid item xs={6}>
                            <Button variant="outlined" component="label" fullWidth size="medium" sx={{ borderRadius: 2, bgcolor: 'white' }}>
                                Est. Card (Img)
                                <input type="file" hidden name="establishment_card" accept="image/*" onChange={handleFileChange} />
                            </Button>
                            {files.establishment_card && <Typography variant="caption" display="block" noWrap sx={{ mt: 0.5, color: 'primary.main', fontWeight: 'bold' }}>✓ {files.establishment_card.name}</Typography>}
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="outlined" component="label" fullWidth size="medium" sx={{ borderRadius: 2, bgcolor: 'white' }}>
                                Application (PDF)
                                <input type="file" hidden name="application_pdf" accept="application/pdf" onChange={handleFileChange} />
                            </Button>
                            {files.application_pdf && <Typography variant="caption" display="block" noWrap sx={{ mt: 0.5, color: 'primary.main', fontWeight: 'bold' }}>✓ {files.application_pdf.name}</Typography>}
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 1, bgcolor: '#f8fafc' }}>
            <Button onClick={() => setOpenAdd(false)} sx={{ fontWeight: 'bold', color: 'text.secondary' }}>Cancel</Button>
            <Button onClick={handleCreate} variant="contained" disabled={createLoading || !newClient.name.trim() || !newClient.email.trim() || !newClient.phone.trim() || (() => {
                const sel = countries.find(c => String(c.id) === String(newClient.country_id));
                const isQK = sel && ['qatar', 'kuwait'].includes(sel.name.toLowerCase());
                const allUploaded = files.license_1 && files.license_2 && files.tax_card && files.establishment_card && files.application_pdf;
                return newClient.account_type === 'CRM' && isQK && !allUploaded;
              })()} sx={{ borderRadius: 2, px: 4, fontWeight: 'bold', boxShadow: '0 4px 14px rgba(25,118,210,0.4)', background: 'linear-gradient(45deg, #1976d2 0%, #42a5f5 100%)' }}>
              {createLoading ? 'Creating User...' : 'Create Client'}
            </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default Clients;
